// AI Mode types

export interface AiConversation {
  id: string
  title: string | null
  status: "active" | "archived"
  context_type: string | null
  context_id: string | null
  message_count: number
  last_message_at: string | null
  created_at: string
}

export interface AiMessage {
  id: string
  role: "user" | "assistant" | "system" | "tool"
  content: string | null
  tool_calls: AiToolCall[] | null
  tool_results: AiToolResult[] | null
  status: "pending" | "streaming" | "completed" | "error"
  created_at: string
}

export interface AiToolCall {
  id: string
  name: string
  arguments: string
}

export interface AiToolResult {
  tool_call_id: string
  name: string
  result: string
}

// ActionCable stream message types
export type AiStreamMessage =
  | { type: "delta"; content: string; conversation_id: string; message_id: string }
  | { type: "tool_start"; tool_name: string; tool_call_id: string; conversation_id: string; message_id: string }
  | { type: "tool_result"; tool_call_id: string; tool_name: string; result: unknown; conversation_id: string; message_id: string }
  | { type: "done"; conversation_id: string; message_id: string; content: string }
  | { type: "error"; conversation_id: string; error: string }

// Context derived from current route
export interface AiContext {
  current_page: string
  context_type?: string
  context_id?: string
  context_label?: string
}

// Tool display names for Polish UI
export const TOOL_LABELS: Record<string, string> = {
  global_search: "Wyszukiwanie globalne",
  search_companies: "Szukanie firm",
  get_company: "Pobieranie firmy",
  create_company: "Tworzenie firmy",
  update_company: "Aktualizacja firmy",
  search_contacts: "Szukanie kontaktów",
  get_contact: "Pobieranie kontaktu",
  create_contact: "Tworzenie kontaktu",
  update_contact: "Aktualizacja kontaktu",
  search_deals: "Szukanie transakcji",
  get_deal: "Pobieranie transakcji",
  get_pipeline_summary: "Podsumowanie pipeline",
  create_deal: "Tworzenie transakcji",
  update_deal: "Aktualizacja transakcji",
  change_deal_phase: "Zmiana fazy transakcji",
  mark_deal_won: "Oznaczanie wygranej",
  mark_deal_lost: "Oznaczanie przegranej",
  search_tasks: "Szukanie zadań",
  get_task: "Pobieranie zadania",
  get_my_tasks: "Moje zadania",
  create_task: "Tworzenie zadania",
  complete_task: "Zamykanie zadania",
  search_invoices: "Szukanie faktur",
  get_invoice: "Pobieranie faktury",
  search_quotes: "Szukanie ofert",
  get_quote: "Pobieranie oferty",
  search_products: "Szukanie produktów",
  get_product: "Pobieranie produktu",
  search_tickets: "Szukanie zgłoszeń",
  get_ticket: "Pobieranie zgłoszenia",
  search_activities: "Szukanie aktywności",
  get_upcoming_activities: "Nadchodzące aktywności",
  get_dashboard_stats: "Statystyki dashboardu",
  get_revenue_trend: "Trend przychodów",
  navigate_to: "Nawigacja",
  create_note: "Tworzenie notatki",
  log_activity: "Logowanie aktywności",
  draft_email: "Tworzenie szkicu email",
  analyze_sales_performance: "Analiza sprzedaży",
  compare_periods: "Porównanie okresów",
  get_deal_forecast: "Prognoza sprzedaży",
  summarize_entity_history: "Historia encji",
  web_search: "Wyszukiwanie w sieci",
}
